import { LeaderboardWithResults } from '../models/LeaderboardWithResults';
import { BaseClient } from './BaseClient';

const getSiteApiBaseUrl = (type: string): string => {
  switch (type) {
    case 'gtsim':
      return process.env.REACT_APP_GTR_API_BASE_URL || '';
    case 'vegas':
      return process.env.REACT_APP_VEGAS_API_BASE_URL || '';
    default:
      throw new Error(`Invalid site type: ${type}`);
  }
};

class SiteClient extends BaseClient {

  public async getLeaderboardById(type: string, id: string, days?: string | null, count?: string | null): Promise<LeaderboardWithResults> {
    const search = new URLSearchParams();
    if (days) search.append('days', days);
    if (count) search.append('count', count);
    const query = search.toString();

    const baseUrl = getSiteApiBaseUrl(type);
    const url = `${baseUrl}racedata/top/boards/${id}${query ? `?${query}` : ''}`;

    const response = await this.fetchWithAuth(url, { method: 'GET' });
    if (!response.ok) {
      throw new Error(`Failed to load GTR leaderboard ${id} (${response.status})`);
    }
    return (await response.json()) as LeaderboardWithResults;
  }
}

const siteApi = new SiteClient();
export default siteApi;
